import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Button from "../Button";

const CircularProgress = ({ percentage = 88, size = 128, strokeWidth = 10, color = "#0A860F" }) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - percentage / 100);

  return (
    <div className="relative" style={{ width: size, height: size }}>
      <svg className="h-full w-full -rotate-90 transform" width={size} height={size}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke="#e5e7eb"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="transparent"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: "stroke-dashoffset 0.6s ease" }}
        />
      </svg>

      <div className="absolute inset-0 flex items-center justify-center text-2xl font-bold text-black">
        {percentage}%
      </div>
    </div>
  );
};

const AdoptResult = ({ pet, scoreLog, onFinish }) => {
  const [color, setColor] = useState("");
  const [title, setTitle] = useState("");
  const [desc, setDesc] = useState([""]);

  const navigate = useNavigate();

  useEffect(() => {
    let c = "#0A860F";
    let t = `${pet.name} and you are a strong match`;
    let d = [
      `You align on the most important areas — lifestyle, energy level, and daily needs. ${pet.name} is very likely to thrive in a home like yours.`,
    ];

    const score = getScoreValue();
    if (score < 80 && score > 50) {
      c = "#FFA552";
      t = `${pet.name} and you are good match`;
      d = [
        `You align on several key areas, though some needs or routines may require extra attention. With patience and consistency, this has the potential to become a wonderful match.`,
      ];
    }
    if (score <= 50) {
      c = "red";
      t = `This may not be the right fit`;
      d = [
        `There are significant differences in lifestyle or daily needs that could make long-term compatibility difficult. To protect ${pet.name}’s wellbeing, this match can’t move forward.`,
        `But don’t worry — we’ll help you find a dog who’s a better fit for your home.`,
      ];
    }

    setColor(c);
    setTitle(t);
    setDesc(d);
  }, [scoreLog]);

  const getScoreValue = () => {
    const score = scoreLog.reduce((acc, l) => {
      return (acc += l.adjustment);
    }, 0);

    return 100 - score;
  };

  return (
    <div className="mt-3 flex max-w-xl flex-col items-center justify-center gap-4 border-t-[1px] pt-6 text-center">
      <div className="text-[20px] font-medium">{title}</div>
      <div className="text-[14px]">Compatibility score</div>
      <CircularProgress percentage={getScoreValue()} color={color} />
      <div className="flex flex-col gap-3">
        {desc.map((d, index) => (
          <div key={index}>{d}</div>
        ))}
      </div>
      <Button
        title={getScoreValue() <= 50 ? "Explore better matches" : "Continue with adoption"}
        theme="dark"
        size="medium"
        onClick={getScoreValue() <= 50 ? () => navigate("/") : onFinish}
      />
    </div>
  );
};

export default AdoptResult;
